"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { FUSportsMatchEvent } from "fansunited-data-layer";
import { SubOutIcon, SubInIcon } from "@/components/ui/icons/PlayerEventIcons";
import { PlayerImage } from "./PlayerImage";
import { PlayerLink } from "./PlayerLink";
import { getPlayerPhoto, type EventLabels } from "./matchEventHelpers";
interface SubstitutionCardProps {
  event: FUSportsMatchEvent;
  showPhotos: boolean;
  eventLabels: EventLabels;
}

/**
 * SubstitutionCard - Displays a substitution event with player in/out
 */
export const SubstitutionCard: React.FC<SubstitutionCardProps> = t0 => {
  const $ = _c(32);
  const {
    event,
    showPhotos,
    eventLabels
  } = t0;
  const playerOut = event.primaryPlayer;
  const playerIn = event.secondaryPlayer;
  let t1;
  if ($[0] !== playerOut) {
    t1 = getPlayerPhoto(playerOut);
    $[0] = playerOut;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const playerOutPhoto = t1;
  let t2;
  if ($[2] !== playerIn) {
    t2 = getPlayerPhoto(playerIn);
    $[2] = playerIn;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const playerInPhoto = t2;
  let t3;
  if ($[4] !== eventLabels.substitution) {
    t3 = <div className="flex items-center gap-1.5 mb-2"><span className="text-xs font-semibold text-muted-foreground uppercase">{eventLabels.substitution}</span></div>;
    $[4] = eventLabels.substitution;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SubOutIcon />;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== playerOut?.name || $[8] !== playerOutPhoto || $[9] !== showPhotos) {
    t5 = showPhotos && <PlayerImage photoUrl={playerOutPhoto} name={playerOut?.name || "Unknown"} />;
    $[7] = playerOut?.name;
    $[8] = playerOutPhoto;
    $[9] = showPhotos;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = playerOut?.id;
  const t7 = playerOut?.name || "Unknown";
  let t8;
  if ($[11] !== t6 || $[12] !== t7) {
    t8 = <PlayerLink playerId={t6} className="text-sm text-foreground/70 min-w-0 flex-1">{t7}</PlayerLink>;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] !== t5 || $[15] !== t8) {
    t9 = <div className="flex items-center gap-2 mb-1.5">{t4}{t5}{t8}</div>;
    $[14] = t5;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <SubInIcon />;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== playerIn?.name || $[19] !== playerInPhoto || $[20] !== showPhotos) {
    t11 = showPhotos && <PlayerImage photoUrl={playerInPhoto} name={playerIn?.name || "Unknown"} />;
    $[18] = playerIn?.name;
    $[19] = playerInPhoto;
    $[20] = showPhotos;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = playerIn?.id;
  const t13 = playerIn?.name || "Unknown";
  let t14;
  if ($[22] !== t12 || $[23] !== t13) {
    t14 = <PlayerLink playerId={t12} className="text-sm font-semibold text-foreground min-w-0 flex-1">{t13}</PlayerLink>;
    $[22] = t12;
    $[23] = t13;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t11 || $[26] !== t14) {
    t15 = <div className="flex items-center gap-2">{t10}{t11}{t14}</div>;
    $[25] = t11;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t15 || $[29] !== t3 || $[30] !== t9) {
    t16 = <div className="bg-muted border border-border rounded-lg p-3 shadow-sm min-w-0 w-48 md:w-72">{t3}{t9}{t15}</div>;
    $[28] = t15;
    $[29] = t3;
    $[30] = t9;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};